var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const validateGtag = /* @__PURE__ */ __name(() => {
  const isInit = typeof gtag === "function";
  if (!isInit) console.warn("gtag is not initialised");
  return isInit;
}, "validateGtag");
const validatePageViewEvent = /* @__PURE__ */ __name((gaEvent2) => {
  const { action } = gaEvent2;
  if (!action) console.error("Action is required");
  if (action && typeof action !== "string") console.error("Action must be a string");
}, "validatePageViewEvent");
const gaPageView = /* @__PURE__ */ __name((gaEvent2, gaId) => {
  if (!validateGtag()) return;
  validatePageViewEvent(gaEvent2);
  const { action } = gaEvent2;
  gtag("event", action, {
    send_to: gaId
  });
}, "gaPageView");
const validateGaEvent = /* @__PURE__ */ __name((gaEvent2) => {
  const { action, category, label, value } = gaEvent2;
  if (!category) console.error("Category is required");
  if (!action) console.error("Action is required");
  if (label && typeof label !== "string") console.error("Label must be a string");
  if (value && typeof value !== "number") console.error("Value must be a number");
}, "validateGaEvent");
const gaEvent = /* @__PURE__ */ __name((gaEvent2) => {
  if (!validateGtag()) return;
  validateGaEvent(gaEvent2);
  const { action, category, label, value } = gaEvent2;
  gtag("event", action, {
    event_category: category,
    event_label: label,
    value
  });
}, "gaEvent");

export { gaEvent, gaPageView, validateGaEvent, validateGtag, validatePageViewEvent };
